export { default as FeaturedImage } from "./FeaturedImage";
